import { useEffect } from 'react';
import { HubspotCreditsHero } from '../../components/hubspot-credits/HubspotCreditsHero';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubspotCreditsPage = () => {
  useEffect(() => {
    trackPageView({
      screen: 'hubspot-credits'
    });
  }, []);
  return /*#__PURE__*/_jsx(HubspotCreditsHero, {});
};